export default __webpack_public_path__ + "static/media/Franco La Cecla.9ecc7e53.jpg";